import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import { useField } from 'formik';
import Input from './Input';
import Textarea from './Textarea';
import Select from './Select';
import Radio from './Radio';
import Checkbox from './Checkbox';
import Toggle from './Toggle';
import { jsx as ___EmotionJSX } from "@emotion/react";

const FormikField = _ref => {
  let {
    as = 'input'
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["as"]);

  const [field, meta] = useField(rest);
  const Component = React.useMemo(() => {
    // eslint-disable-next-line default-case
    switch (as) {
      case 'input':
        return Input;

      case 'textarea':
        return Textarea;

      case 'select':
        return Select;

      case 'radio':
        return Radio;

      case 'checkbox':
        return Checkbox;

      case 'toggle':
        return Toggle;
    }
  }, [as]);
  const errorText = meta.error && meta.touched ? meta.error : '';
  const componentProps = {
    validationMessage: errorText
  }; // Remove `errorText` prop from fields that don't support `validationMessage` to avoid DOM warning

  if (['radio', 'checkbox', 'toggle'].includes(as)) {
    delete componentProps.validationMessage;
  }

  return ___EmotionJSX(Component, _extends({}, field, rest, componentProps));
};

export default FormikField;